import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

export const triggerGetSuggestedQuestions = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.map(() =>
        feature.actions.getSuggestedQuestions.request
          .from('ContextChange')
          .create(),
      ),
    ),
)
